<template>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <div class="headline">
            {{ getSnippets('Menu') }}
          </div>
          <ul class="navigation-list">
            <li v-for="item in data.navigation.main" :key="item.id">
              <router-link :to="{ path: item.slug }">{{ getTranslation(item, 'title') }}</router-link>
            </li>
          </ul>
        </div>
        <div class="col-md-3">
          <div class="headline">
            {{ getSnippets('Other') }}
          </div>
          <ul class="navigation-list">
            <li v-for="item in data.navigation.footer" :key="item.id">
              <router-link :to="{ path: item.slug }">{{ getTranslation(item, 'title') }}</router-link>
            </li>
          </ul>
        </div>
        <div class="col-md-6">
          <div class="headline">
            {{ getSnippets('Contact') }}
          </div>
          <ul class="navigation-list last">
            <li>
              <a :href="`tel:${getSnippets('Company Phone')}`" target="_blank">
                T: {{ getSnippets('Company Phone') }}
              </a>
            </li>
            <li>
              <a :href="`mailto:${getSnippets('Company Email')}`" target="_blank">
                E: {{ getSnippets('Company Email') }}
              </a>
            </li>
            <li>
              A: {{ getSnippets('Company Address') }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="copyright">
      {{ getSnippets('Copyright') }} © {{ new Date() | moment("YYYY") }}
    </div>
  </footer>
</template>

<script>
/* Mixins */
import {Default} from '@mixins/Default';

/* Logic */
export default {
  name: 'Footer',
  mixins: [Default],
  props: [
    'data'
  ]
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/App/Partials/Footer.vue